import { render } from "./EventDetail.vue?vue&type=template&id=33e36435&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=33e36435&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-33e36435"

export default script